var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { forwardRef } from 'react';
import { Tooltip } from 'modules/v2/dataDisplay/Tooltip';
import { IconToggleButtonContainer } from './styled';
export const IconToggleButton = forwardRef((props, ref) => {
    const { children, 'aria-label': ariaLabel, tooltip } = props, rest = __rest(props, ["children", 'aria-label', "tooltip"]);
    const disabledTooltip = !ariaLabel;
    return (<Tooltip disabled={disabledTooltip} title={ariaLabel} {...tooltip}>
      <IconToggleButtonContainer aria-label={ariaLabel} type="button" ref={ref} {...rest}>
        {children}
      </IconToggleButtonContainer>
    </Tooltip>);
});
